import React from "react";
import CustomModal from "./../../../components/CustomModal";

const PackageProposalModal = props => {
    const { isModalShown, hideModal, portalContacts } = props;

    const modalContent = (
        <div>
            <p>Du har mulighed for at købe op til syv tags i alt.</p>
            <p>Kontakt venligst salgsafdelingen for yderligere information.</p>
            <div className="card-block p-l-0 p-r-0" key={portalContacts.id}>
                <h4 className="m-t-20 m-b-20">Salg</h4>
                <div className="row" key={portalContacts.id}>
                    {portalContacts.map((contact, key) => {
                        return (
                            <div className="col-md-4 col-lg-4" key={contact.id}>
                                <div className="card m-b-20">
                                    <div className="card-block">
                                        <h4 className="card-title font-20 mt-0">
                                            {contact.name}
                                        </h4>
                                    </div>
                                    <img
                                        className="img-fluid"
                                        src={
                                            contact.photo[0] !== undefined
                                                ? contact.photo[0].path
                                                : ""
                                        }
                                        alt="Card cap"
                                    />
                                    <div className="card-block">
                                        <b className="text-muted">Tlf.: </b>{" "}
                                        <a
                                            href={`tel:${contact.phone}`}
                                            className="common-decor"
                                        >
                                            {contact.phone}
                                        </a>
                                        <p>
                                            <a
                                                href={`mailto:${contact.email}`}
                                                className="common-decor"
                                            >
                                                {contact.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );

    return (
        <CustomModal
            modalTitle={"Har du behov for flere tags?"}
            modalContent={modalContent}
            confirmText="Slet"
            closeText="Luk"
            confirmButton={false}
            handleHideModal={hideModal}
            isOpen={isModalShown}
        />
    );
};

export default PackageProposalModal;



// WEBPACK FOOTER //
// ./web/src/components/company/company-form/PackageProposalModal.jsx